import { RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: 'list',
    name: 'location.param-assessments.list',
    component: () => import('@/views/control-panel/projects/project/sections/section/measure-locations/measure-location/paramAssessments/List.vue'),
  }
]

export default routes
